<div class="section-rule">
  <bodyanalytics-eyebrow>{{ label() }}</bodyanalytics-eyebrow>
  <hr class="section-rule__line" />
</div>
